import { freddyTheme } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
export const getAnimatedBannerProgressBarStyle = ({ startLoading, currentSlide, barPosition, }) => ({
    flex: 1,
    height: '0.3rem',
    overflow: 'hidden',
    borderRadius: '0.15rem',
    position: 'relative',
    backgroundColor: freddyTheme.color.background.tertiary,
    '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: barPosition < currentSlide ? '100%' : '0',
        height: '100%',
        backgroundColor: freddyTheme.color.background.primary,
        animation: startLoading && barPosition === currentSlide ? `${animateProgressBar()} 5s linear` : 'none',
    },
});
const animateProgressBar = () => keyframes `
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;
//# sourceMappingURL=getAnimatedBannerProgressBarStyle.js.map